module.exports = __webpack_public_path__ + "img/WDB_DM.880163c6.png";